import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from "react";
import eventBus from "../EventBus";
const LoadingScreen = () => {
    const [progress, setProgress] = useState(0);
    const [toLoad, setToLoad] = useState(0);
    const [loaded, setLoaded] = useState(0);
    const [overlayOpacity, setLoadingOverlayOpacity] = useState(1);
    const [loadingTextOpacity, setLoadingTextOpacity] = useState(1);
    const [startPopupOpacity, setStartPopupOpacity] = useState(0);
    const [firefoxPopupOpacity, setFirefoxPopupOpacity] = useState(0);
    const [webGLErrorOpacity, setWebGLErrorOpacity] = useState(0);
    const [showBiosInfo, setShowBiosInfo] = useState(false);
    const [showLoadingResources, setShowLoadingResources] = useState(false);
    const [doneLoading, setDoneLoading] = useState(false);
    const [webGLError, setWebGLError] = useState(false);
    const [counter, setCounter] = useState(0);
    const [resources] = useState([]);
    const [mobileWarning, setMobileWarning] = useState(window.innerWidth < 768);
    const onResize = () => {
        if (window.innerWidth < 768) {
            setMobileWarning(true);
        }
        else {
            setMobileWarning(false);
        }
    };
    window.addEventListener("resize", onResize);
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("debug")) {
            start();
        }
        else if (!detectWebGLContext()) {
            setWebGLError(true);
        }
        else {
            setShowBiosInfo(true);
        }
    }, []);
    useEffect(() => {
        eventBus.on("loadedSource", (data) => {
            setProgress(data.progress);
            setToLoad(data.toLoad);
            setLoaded(data.loaded);
            resources.push(`Loaded ${data.sourceName}${getSpace(data.sourceName)} ... ${Math.round(data.progress * 100)}%`);
            if (resources.length > 8) {
                resources.shift();
            }
        });
    }, []);
    useEffect(() => {
        setShowLoadingResources(true);
        setCounter(counter + 1);
    }, [loaded]);
    useEffect(() => {
        if (progress >= 1 && !webGLError) {
            setDoneLoading(true);
            setTimeout(() => {
                setLoadingTextOpacity(0);
                setTimeout(() => {
                    setStartPopupOpacity(1);
                }, 500);
            }, 1000);
        }
    }, [progress]);
    useEffect(() => {
        if (webGLError) {
            setTimeout(() => {
                setWebGLErrorOpacity(1);
            }, 500);
        }
    }, [webGLError]);
    const start = useCallback(() => {
        setLoadingOverlayOpacity(0);
        eventBus.dispatch("loadingScreenDone", {});
        const ui = document.getElementById("ui");
        if (ui) {
            ui.style.pointerEvents = "none";
        }
    }, []);
    const getSpace = (sourceName) => {
        let spaces = "";
        for (let i = 0; i < 24 - sourceName.length; i++)
            spaces += "\xa0";
        return spaces;
    };
    const getCurrentDate = () => {
        const date = new Date();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        const year = date.getFullYear();
        // add leading zero
        const monthFormatted = month < 10 ? `0${month}` : month;
        const dayFormatted = day < 10 ? `0${day}` : day;
        return `${monthFormatted}/${dayFormatted}/${year}`;
    };
    const detectWebGLContext = () => {
        var canvas = document.createElement("canvas");
        // Get WebGLRenderingContext from canvas element.
        var gl = canvas.getContext("webgl") || canvas.getContext("experimental-webgl");
        // Report the result.
        if (gl && gl instanceof WebGLRenderingContext) {
            return true;
        }
        return false;
    };
    return (_jsxs("div", Object.assign({ style: Object.assign({}, styles.overlay, {
            opacity: overlayOpacity,
            transform: `scale(${overlayOpacity === 0 ? 1.1 : 1})`,
        }) }, { children: [startPopupOpacity === 0 && loadingTextOpacity === 0 && (_jsx("div", Object.assign({ style: styles.blinkingContainer }, { children: _jsx("span", { className: "blinking-cursor" }) }))), !webGLError && (_jsxs("div", Object.assign({ style: Object.assign({}, styles.overlayText, {
                    opacity: loadingTextOpacity,
                }) }, { children: [_jsxs("div", Object.assign({ style: styles.header, className: "loading-screen-header" }, { children: [_jsx("div", Object.assign({ style: styles.logoContainer }, { children: _jsxs("div", { children: [_jsxs("p", Object.assign({ style: styles.green }, { children: [_jsx("b", { children: "Nolan," }), " "] })), _jsx("p", Object.assign({ style: styles.green }, { children: _jsx("b", { children: "Brandon Inc." }) }))] }) })), _jsxs("div", Object.assign({ style: styles.headerInfo }, { children: [_jsx("p", { children: "Released: 01/13/2000" }), _jsx("p", { children: "HHBIOS (C)2000 Nolan Brandon Inc.," })] }))] })), _jsxs("div", Object.assign({ style: styles.body, className: "loading-screen-body" }, { children: [_jsx("p", { children: "HSP S13 2000-2025 Special UC131S" }), _jsx("div", { style: styles.spacer }), showBiosInfo && (_jsxs(_Fragment, { children: [_jsx("p", { children: "HSP Showcase(tm) XX 113" }), _jsxs("p", { children: ["Checking RAM : ", 14000, " OK"] }), _jsx("div", { style: styles.spacer }), _jsx("div", { style: styles.spacer }), showLoadingResources ? (progress == 1 ? (_jsx("p", { children: "FINISHED LOADING RESOURCES" })) : (_jsxs("p", Object.assign({ className: "loading" }, { children: ["LOADING RESOURCES (", loaded, "/", toLoad === 0 ? "-" : toLoad, ")"] })))) : (_jsx("p", Object.assign({ className: "loading" }, { children: "WAIT" })))] })), _jsx("div", { style: styles.spacer }), _jsx("div", Object.assign({ style: styles.resourcesLoadingList }, { children: resources.map((sourceName) => (_jsx("p", { children: sourceName }, sourceName))) })), _jsx("div", { style: styles.spacer }), showLoadingResources && doneLoading && (_jsxs("p", { children: ["All Content Loaded, launching", " ", _jsx("b", Object.assign({ style: styles.green }, { children: "'Brandon Nolan Portfolio Showcase'" })), " ", "V1.0"] })), _jsx("div", { style: styles.spacer }), _jsx("span", { className: "blinking-cursor" })] })), _jsxs("div", Object.assign({ style: styles.footer, className: "loading-screen-footer" }, { children: [_jsxs("p", { children: ["Press ", _jsx("b", { children: "DEL" }), " to enter SETUP , ", _jsx("b", { children: "ESC" }), " to skip memory test"] }), _jsx("p", { children: getCurrentDate() })] }))] }))), _jsx("div", Object.assign({ style: Object.assign({}, styles.popupContainer, {
                    opacity: startPopupOpacity,
                }) }, { children: _jsxs("div", Object.assign({ style: styles.startPopup }, { children: [_jsx("p", { children: "Brandon Nolan Portfolio Showcase 2025" }), mobileWarning && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs("b", { children: [_jsx("p", Object.assign({ style: styles.warning }, { children: "WARNING: This experience is best viewed on" })), _jsx("p", Object.assign({ style: styles.warning }, { children: "a desktop or laptop computer." }))] }), _jsx("br", {})] })), _jsxs("div", Object.assign({ style: { display: "flex", alignItems: "flex-end" } }, { children: [_jsxs("p", { children: ["Click start to begin", "\xa0"] }), _jsx("span", { className: "blinking-cursor" })] })), _jsx("div", Object.assign({ style: {
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                marginTop: "16px",
                            } }, { children: _jsx("div", Object.assign({ className: "bios-start-button", onClick: start }, { children: _jsx("p", { children: "START" }) })) }))] })) })), webGLError && (_jsx("div", Object.assign({ style: Object.assign({}, styles.popupContainer, {
                    opacity: webGLErrorOpacity,
                }) }, { children: _jsxs("div", Object.assign({ style: styles.startPopup }, { children: [_jsxs("p", { children: [_jsx("b", Object.assign({ style: { color: "red" } }, { children: "CRITICAL ERROR:" })), " No WebGL Detected"] }), _jsx("div", { style: styles.spacer }), _jsx("div", { style: styles.spacer }), _jsx("p", { children: "WebGL is required to run this site." }), _jsx("p", { children: "Please enable it or switch to a browser which supports WebGL" })] })) })))] })));
};
const styles = {
    overlay: {
        backgroundColor: "black",
        width: "100%",
        height: "100%",
        display: "flex",
        transition: "opacity 0.2s, transform 0.2s",
        MozTransition: "opacity 0.2s, transform 0.2s",
        WebkitTransition: "opacity 0.2s, transform 0.2s",
        OTransition: "opacity 0.2s, transform 0.2s",
        msTransition: "opacity 0.2s, transform 0.2s",
        transitionTimingFunction: "ease-in-out",
        MozTransitionTimingFunction: "ease-in-out",
        WebkitTransitionTimingFunction: "ease-in-out",
        OTransitionTimingFunction: "ease-in-out",
        msTransitionTimingFunction: "ease-in-out",
        boxSizing: "border-box",
        fontSize: 16,
        letterSpacing: 0.8,
    },
    spacer: {
        height: 16,
    },
    header: {
        width: "100%",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
    },
    popupContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    warning: {
        color: "yellow",
    },
    blinkingContainer: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        boxSizing: "border-box",
        padding: 48,
    },
    startPopup: {
        backgroundColor: "#000",
        padding: 24,
        border: "7px solid #fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        maxWidth: 500,
        // alignItems: 'center',
    },
    headerInfo: {
        marginLeft: 64,
    },
    red: {
        color: "#00ff00",
    },
    link: {
        // textDecoration: 'none',
        color: "#4598ff",
        cursor: "pointer",
    },
    overlayText: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
    },
    body: {
        flex: 1,
        display: "flex",
        width: "100%",
        boxSizing: "border-box",
        flexDirection: "column",
    },
    logoContainer: {
        display: "flex",
        flexDirection: "row",
    },
    resourcesLoadingList: {
        display: "flex",
        paddingLeft: 32,
        paddingBottom: 32,
        flexDirection: "column",
    },
    logoImage: {
        width: 64,
        height: 42,
        imageRendering: "pixelated",
        marginRight: 16,
    },
    footer: {
        boxSizing: "border-box",
        width: "100%",
    },
};
export default LoadingScreen;
